import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";
import {
  SettingsInterface,
  ActiveInterface,
  AssetsTypesInterface,
} from "@/types";
import { copy } from "@/utils";
import api from "@/apiClient";
import config from "@/config";

const defaultActive = (): ActiveInterface => ({
  assets: {
    id: 0,
    name: "",
    type: 0,
    title: "",
  },
});

@Module
export default class SettingsModule extends VuexModule {
  private tabsLoader = false;
  private settings: AssetsTypesInterface[] = [];
  private active: ActiveInterface = defaultActive();
  private errorMessage = "";

  @Action
  public async Load(): Promise<void> {
    this.setTabsLoader(true);
    try {
      const data: SettingsInterface = await api.settings.fetch();

      if (!data || !Array.isArray(data.assets_types)) {
        throw new Error("Invalid settings payload");
      }

      this.setSettings(data.assets_types);

      const hasActive =
        Object.values(this.getActive.assets).filter(Boolean).length > 0;

      if (!hasActive) {
        const activeDefault = this.getActiveDefault;
        this.Active(activeDefault);
      }
    } catch (error) {
      console.error("Error loading settings:", error);
      this.setErrorMessage("Neizdevās ielādēt iestatījumus.");
    } finally {
      this.setTabsLoader(false);
    }
  }

  @Action
  public Active(tab: ActiveInterface | null): void {
    if (tab && this.getActive.assets.name === tab.assets.name) return;
    this.setActive(tab);
  }

  @Action
  public Reset(): void {
    const activeDefault = this.getActiveDefault;
    this.Active(activeDefault);
  }

  @Mutation
  private setTabsLoader(loader: boolean): void {
    this.tabsLoader = loader;
  }

  @Mutation
  private setSettings(settings: AssetsTypesInterface[]): void {
    this.settings = settings;
  }

  @Mutation
  private setActive(active: ActiveInterface | null): void {
    if (!active) {
      this.active = defaultActive();
    } else {
      this.active = {
        assets: { ...active.assets },
      };
    }
  }

  @Mutation
  private setErrorMessage(message: string): void {
    this.errorMessage = message;
  }

  get getTabsLoader(): boolean {
    return this.tabsLoader;
  }

  private get getActiveDefault(): ActiveInterface {
    const [first] = this.getSettings;
    if (first) {
      return { assets: first };
    }
    return defaultActive();
  }

  get getActive(): ActiveInterface {
    return this.active;
  }

  get getSettings(): AssetsTypesInterface[] {
    const visibleTabs: AssetsTypesInterface[] = copy(this.settings).filter((tab: AssetsTypesInterface) => tab.visible);

    if (!visibleTabs.length) {
      return [];
    }

    const offset = visibleTabs.length;
    const albumsFromConfig = (config.assets as AssetsTypesInterface[]).map(
      (tab, index) => ({
        ...tab,
        id: offset + index + 1,
      })
    );

    return [...albumsFromConfig, ...visibleTabs];
  }
}
